<template>
  <div>
    <top />
    <div class="location home">
      当前位置：
      <router-link :to="{ path: '/' }" class="a">首页</router-link>&nbsp;&gt;&nbsp;
      <a class="a" href="javascript:;">产品介绍</a>
    </div>
    <el-tabs type="border-card" class="home" :tab-position="tabPosition">
      <el-tab-pane label="总体介绍">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>《国研网系列研究报告》平台</strong>是国研网独家发布自主研发系列报告的网络平台，致力于通过持续跟踪、分析国内外宏观经济、金融和重点行业基本运行态势、发展趋势，准确解读相关政策趋势和影响，及时研究各领域热点、重点问题，为客户提供经济、金融、行业研究和战略决策需要的高端信息产品。
        </p>
        <p>
          平台除及时发布国研网自主研发的系列跟踪研究报告产品——周评（37种）、月报（35种）、季报（25种）、年报（48种）、热点报告（36种），以及国研网个性化定制报告服务领域及成功案例介绍，是用户全面了解国研网研究领域，获取国研网独家研究报告的窗口。
        </p>
        <h5 class="title_b">国研网系列研究报告</h5>
        <table class="table" border="1" width="80%" cellspacing="0" cellpadding="0">
          <tr style="background: #072e5d; color:#fff;">
            <th>序列</th>
            <th>类别</th>
            <th>周评</th>
            <th>月报</th>
            <th>季报</th>
            <th>年报</th>
            <th>热点报告</th>
          </tr>
          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>Ⅰ</td>
            <td style="width:200px;">宏观综合类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>1</td>
            <td>宏观经济</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
          </tr>
          <tr>
            <td>2</td>
            <td>农业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>3</td>
            <td>科技创新</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>4</td>
            <td>双碳经济</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>5</td>
            <td>地方债</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>6</td>
            <td>地方投融资</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>

          <!-- <tr>
            <td>3</td>
            <td>建筑行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->
          <tr>
            <td>7</td>
            <td>智慧城市建设行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>

          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>Ⅱ</td>
            <td>金融行业类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>8</td>
            <td>国际金融</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>9</td>
            <td>国内金融</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>10</td>
            <td>绿色金融</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>11</td>
            <td>财富管理</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>12</td>
            <td>银行</td>
            <td>√（2）*</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>13</td>
            <td>保险</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>14</td>
            <td>证券</td>
            <td>√（2）*</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>


          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>Ⅲ</td>
            <td>能源资源类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>15</td>
            <td>电力行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>16</td>
            <td>石油行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>17</td>
            <td>煤炭行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <!-- <tr>
            <td>18</td>
            <td>铁矿石</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->

          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>IV</td>
            <td>传统制造类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>18</td>
            <td>汽车行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>19</td>
            <td>钢铁行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>20</td>
            <td>医药行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>21</td>
            <td>化工行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>22</td>
            <td>食品制造</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>23</td>
            <td>有色金属</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>24</td>
            <td>纺织服装</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <!-- <tr>
            <td>26</td>
            <td>机械行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->

          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>V</td>
            <td>服务业类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>25</td>
            <td>房地产业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>26</td>
            <td>通信行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>27</td>
            <!-- <td>交通运输（周报、月报、热点报告为港口航运业）</td> -->
            <td>交通运输</td>
            <td></td>
            <td></td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>28</td>
            <td>港口航运业</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>29</td>
            <td>旅游行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>30</td>
            <td>物流行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>31</td>
            <td>零售业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>32</td>
            <td>养老产业</td>
            <td>√</td>
            <td>√</td>
            <td></td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>33</td>
            <td>服务消费</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <!-- <tr>
            <td>31</td>
            <td>软件行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->
          <!-- <tr>
            <td>35</td>
            <td>养老行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->

          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>VI</td>
            <td>战略新兴类</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>34</td>
            <td>量子科技</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>35</td>
            <td>新一代信息技术行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>36</td>
            <td>电子信息制造业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>37</td>
            <td>集成电路产业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>38</td>
            <td>新能源行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>39</td>
            <td>新能源汽车行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>40</td>
            <td>文化创意产业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>41</td>
            <td>高端装备制造业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>42</td>
            <td>电子商务行业</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
            <td>√</td>
          </tr>
          <tr>
            <td>43</td>
            <td>生物产业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>44</td>
            <td>健康产业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>45</td>
            <td>大数据行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>46</td>
            <td>云计算行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>47</td>
            <td>数字经济</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>

          <tr>
            <td>48</td>
            <td>人工智能行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>49</td>
            <td>新材料行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>50</td>
            <td>低空经济</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>51</td>
            <td>具身智能</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr style="background:rgb(255, 255, 0); color:black;">
            <td>Ⅻ</td>
            <td>观大势系列</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>52</td>
            <td>重要会议专题</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
          </tr>
          <tr>
            <td>53</td>
            <td>重要政策专题</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
          </tr>
          <!-- <tr>
            <td>46</td>
            <td>互联网行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>47</td>
            <td>物联网行业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr>
          <tr>
            <td>48</td>
            <td>集成电路产业</td>
            <td></td>
            <td></td>
            <td></td>
            <td>√</td>
            <td></td>
          </tr> -->
          <tr style="font-weight: bold;">
            <td colspan="2">合计</td>
            <td>37</td>
            <td>35</td>
            <td>25</td>
            <td>48</td>
            <td>36</td>
          </tr>
        </table>
        <span>注：“银行业周评”包含《银行业监管与市场周评》、《银行业创新动态周评》2种；“证券业周评”包含《证券市场周评》、《并购重组周评》2种。</span>

        <h5 class="title_b">提供方式</h5>
        <table class="table" border="1" width="50%" cellspacing="0" cellpadding="0">
          <tr style="background: #0770b9; color:#fff;">
            <th>报告类型</th>
            <th>提供方式</th>
          </tr>
          <tr style="color:black;">
            <td>周评、月报、季报、热点报告</td>
            <td>线上全文</td>
          </tr>
          <!-- <tr style="color:black;">
            <td>年度报告</td>
            <td>
              线上摘要、目录;
              线下邮件发送全文
            </td>
          </tr>
          <tr style="color:black;">
            <td>专题报告</td>
            <td>
              线上全文
              （未列入产品报价单，需单独订购）
            </td>
          </tr> -->
          <tr style="color:black;">
            <td rowspan="2">定制报告</td>
            <td>线上提供国研网个性化定制报告服务领域及成功案例介绍</td>
          </tr>
          <tr style="color:black;">
            <td>可针对客户具体需求提供报告定制服务（需一事一议，另签协议）</td>
          </tr>
        </table>
      </el-tab-pane>

      <el-tab-pane label="周评">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>国研网系列“周评”</strong>通过及时对政府部门及国内外权威媒体发布的有关宏观、金融、行业领域的重大事件、最新政策、市场动态及运行数据等进行整理分析，力求每周为有关政府、金融机构和投资者提供脉络清楚的动态信息、部分附带观点明晰的评论，从而为正确、快速地研究和决策提供参考。国研网目前已推出
          <strong>37</strong>种周评产品，其中包括
          <strong>1</strong>种宏观类
          <strong>14</strong>种金融及综合类周评和
          <strong>22</strong>种行业周报，每周一更新，每年每领域更新50期左右。
        </p>
        <ul>
          <li>
            <strong>金融周评</strong>为经济形势与政策信息的汇集与分析。
          </li>
          <li>
            <strong>金融及综合类周评</strong>涉及领域：
            <strong>国际金融、国内金融、科技创新、双碳经济、地方债、绿色金融、投融资、并购重组、银行（2）、保险、证券、财富管理、养老金融。行业周评涉及领域：
              农业、电力行业、新能源行业、石油行业、煤炭行业、汽车行业、新能源汽车行业、钢铁行业、医药行业、文化创意产业、化工行业、食品制造、有色金属行业、高端装备制造、房地产业、通信行业、电子信息制造、港口航运、旅游行业、物流行业、电子商务、零售业。</strong>
          </li>
        </ul>
        <h3 class="title">使用价值</h3>
        <ul>
          <li>帮助用户全面、及时地了解国内外经济、金融、行业领域的重要政策与重大事件、把握最新经济、金融、行业市场运行态势。</li>
          <li>科学解读政府有关政策，预测政策变化趋势，揭示政策变化给金融与各行业有关各方带来的风险和机会。</li>
          <li>为相关用户及时、高效地进行科学研究、制定战略决策、指导实际操作等方面提供具有较高参考价值的信息。</li>
        </ul>
      </el-tab-pane>

      <el-tab-pane label="月度报告">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>国研网系列“月度分析报告”</strong>长期跟踪并分析宏观经济、金融、行业主要运行指标的变动情况、变动趋势和变动成因，揭示数据后面隐含的经济规律、全面直观反映经济运行状况、预测未来发展趋势。
        </p>
        <p>
          国研网目前已推出
          <strong>35</strong>种“月度分析报告”，其中包括
          <strong>1</strong>种宏观经济月度分析报告、
          <strong>12</strong>种金融及综合类月度运行分析报告和
          <strong>22</strong>种行业运行分析报告。各领域每年11-12期，通常在主要关注的统计指标数据发布后的5个工作日内上网。
        </p>
        <ul>
          <li>
            <strong>宏观经济月度分析报告</strong>分析跟踪主要宏观指标的变动，揭示数据后面隐含的经济规律、全面直观反映经济运行状况、预测未来发展趋势。
          </li>
          <li>
            <strong>金融及综合类月度运行分析报告</strong>涉及领域：
            <strong>国际金融、国内金融、投融资、地方债、科技创新、双碳经济、绿色金融、养老金融、银行、保险、证券、财富管理。行业月度运行分析报告涉及领域：
              农业、电力行业、新能源行业、石油行业、煤炭行业、汽车行业、新能源汽车行业、钢铁行业、医药行业、文化创意产业、化工行业、食品制造、有色金属行业、高端装备制造、房地产业、通信行业、电子信息制造、港口航运、旅游行业、物流行业、电子商务、零售业。</strong>
          </li>

        </ul>
        <h3 class="title">产品价值</h3>
        <ul>
          <li>以数据为中心，揭示数据背后隐含的经济规律，帮助用户帮助及时了解经济运行动态。</li>
          <li>深入剖析数据指标变化背后的原因，为用户进行相关研究、业务风险管理及决策提供参考。</li>
          <li>前瞻性地对经济指标的变动趋势进行预测，帮助用户洞悉经济、金融、产业未来走势，提高决策的科学性。</li>
        </ul>
      </el-tab-pane>

      <el-tab-pane label="季度报告">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>国研网系列“季度分析报告”</strong>通过持续跟踪、分析宏观经济、金融、行业基本运行态势、发展趋势，准确解读相关政策动向及其影响，致力于为客户提供战略决策需要的、高质量的、宏观/中观层面的信息产品。国研网目前已推出
          <strong>25</strong>种季度分析报告，其中包含
          <strong>1</strong>种宏观经济季度报告、
          <strong>2</strong>种金融季度分析报告、
          <strong>22</strong>种行业季度分析报告。
        </p>
        <p style="font-size:16px;text-align:center;padding:15px 0px 5px 0px;">
          <strong>《宏观经济季度分析报告》</strong>
        </p>
        <p>
          <strong>《宏观经济季度分析报告》（简称“宏观季报”）</strong>致力于宏观经济发展全局的把握与观察，通过对当季经济周期分析、运行分析、宏观要闻与政策倾向以及前景展望等内容的观察总结与分析，为用户提供一份覆盖经济全局、脉络清楚、观点明晰的宏观经济季度研究报告。每期宏观季报1.5万字左右，通常在每个季度结束后的50个工作日内完成并上网发布。年更新数量为4期。
        </p>
        <p style="font-size:16px;text-align:center;padding:15px 0px 5px 0px;">
          <strong>《金融季度分析报告》</strong>
        </p>
        <p>
          <strong>金融季度分析报告：</strong>包含
          <strong>国内金融形势分析季报和 国际金融形势分析季报</strong>。通过对国内金融市场、金融政策、货币运行、国际金融等内容的观察、总结与梳理，力求为用户提供脉络清楚、观点明晰的金融季度分析报告。
        </p>
        <p>
          <strong>[国内金融形势分析季报]</strong>主要对境内货币市场、股票市场、债券市场、外汇市场的总体运行态势进行回顾、分析。
        </p>
        <p>
          <strong>[国际金融形势分析季报]</strong>对全球主要经济体经济状况、主要央行货币政策、各主要股票市场运行、全球外汇市场主要币种走势等方面进行概要性描述、回顾。
        </p>

        <p style="font-size:16px;text-align:center;padding:15px 0px 5px 0px;">
          <strong>《行业季度分析报告》</strong>
        </p>
        <p>
          <strong>《行业季度分析报告》</strong>主要基于国家权威部门统计数据，利用科学方法，分析行业总体运行态势，预测中短期内该行业的发展趋势；对产业政策动向及时进行深入的研究与探讨，剖析行业发展中面临的风险或投资机会，为有关政府、企业和投资者提供决策参考。
        </p>
        <p>
          目前，国研网已经推出
          <strong>农业、电力行业、新能源行业、石油行业、煤炭行业、汽车行业、新能源汽车行业、钢铁行业、医药行业、文化创意产业、化工行业、食品制造、有色金属行业、高端装备制造、房地产业、通信行业、电子信息制造、交通运输、旅游行业、物流行业、电子商务、零售业22</strong>个国民经济发展的热点、重点行业的季度分析报告。每份行业季报2万字左右，通常在每个季度结束后的50天内完成并上网发布，每个行业年更新报告数量为4期。
        </p>
        <p>各行业季度报告主要从三个角度监测和解读行业发展走势：</p>
        <p>
          <strong>1、产业发展环境分析，</strong>主要是监测和解读产业发展面临的产业政策环境变化情况，重点跟踪和研究国家有关政策变化给行业内有关各方带来的机遇和风险。
        </p>
        <p>
          <strong>2、行业运行状况分析，</strong>主要是对政府部门和行业协会等机构发布的有关统计数据进行分析整理，图文并茂，全方位展现行业运行状况及发展态势。
        </p>
        <p>
          <strong>3、行业发展趋势预测，</strong>利用科学方法，对行业未来中短期发展趋势和政策趋势进行分析预测。
        </p>

        <h3 class="title">产品价值</h3>
        <ul>
          <li>通过跟踪当季政策动态走势，科学解读政府有关政策，预测政策变化趋势，揭示政策变化给行业有关各方带来的风险和机会。</li>
          <li>通过对宏观经济、金融、重点行业的运行特点、态势与影响因素做出客观的分析与研判，帮助用户全面、及时、准确地了解经济运行的基本运行态势，面临的主要问题、运行态势变化的原因等。</li>
          <li>通过基于国家权威部门的统计数据、利用科学的方法，对经济、金融、重点行业未来走势做出判断与预测，帮助用户及时把握经济、金融、重点行业未来中短期内的发展趋势。</li>
          <li>为相关用户及时、高效地进行科学研究、制定战略决策、指导实际操作等方面提供具有较高参考价值的信息。</li>
        </ul>
      </el-tab-pane>

      <el-tab-pane label="年度报告">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>国研网系列“年度分析报告”</strong>主要从金融、行业总体发展和政策变迁角度，重点把握金融、行业发展现状和发展趋势；试图从全球化的视角、国内外市场相互联系、相互影响等方面，对金融、行业的总体运行态势进行全方位分析，对金融、行业发展中出现的热点或重点问题尤其是政策走势及时进行深入的研究，并力求预测金融、行业中短期发展趋势，以期能够为政府部门、企事业单位、机构投资者、科研院所等相关机构提供研究和决策参考。
        </p>
        <p>
          国研网目前已推出
          <strong>48</strong>种年报产品，其中包括
          <strong>11</strong>种金融及综合类年报和
          <strong>37</strong>种行业年报。
        </p>
        <ul>
          <li>
            <strong>金融及综合类年报</strong>涉及领域：
            <strong>国际金融、国内金融、科技金融、绿色金融、养老金融、双碳经济、投融资、地方债、银行、保险、证券。</strong>年度报告依据细分领域不同，约为2-5万字，每年4月上网发布。
          </li>
        </ul>
        <p style="font-size:16px;text-align:center;padding:0px 0px 5px 0px;">
          <strong>金融年报内容框架及说明</strong>
        </p>
        <table class="table table1" border="1" width="95%" cellspacing="0" cellpadding="0">
          <tr style="background: #0770b9; color:#fff;">
            <th>框架结构</th>
            <th>内容说明</th>
          </tr>
          <tr style="color:black;">
            <td style="width:140px;">监管与发展政策</td>
            <td>通过分析年度监管政策以及细分领域内业务发展政策，准确把握金融监管思路、细分领域发展重点。</td>
          </tr>
          <tr style="color:black;">
            <td>市场运行情况</td>
            <td>通过最新的数据与图表分析，描述市场运行的走势及特征。包括重要经济指标、金融指标，如社会融资规模、全年货币量、信贷量、募资额、债券余额、基金规模等。</td>
          </tr>
          <tr style="color:black;">
            <td>机构运行情况</td>
            <td>通过对上市银行、上市保险公司、重点券商、期货公司、信托公司等经营数据、经营模式进行分析，掌握金融机构年度运行情况。</td>
          </tr>
          <tr style="color:black;">
            <td>监管政策及趋势展望</td>
            <td>通过分析国内宏观经济发展阶段及特征、当前金融工作重点，准确把握下一阶段金融监管方向、细分领域发展侧重点。</td>
          </tr>
          <tr style="color:black;">
            <td>面临的机遇与挑战</td>
            <td>明确细分领域面临的机遇与挑战，尤其是在金融与科技融合的背景下，细分领域业务、发展模式的创新机遇及面临的挑战。</td>
          </tr>
        </table>
        <p style="color:red;padding:10px 0px;">注：由于各领域特点不同，上述框架只供参考，最终框架以细分领域报告终稿为准。</p>

        <ul>
          <li>
            <strong>行业年报（全称“**行业市场竞争趋势与投资战略分析报告”）</strong>涉及领域：
            <strong>农业、电力行业、新能源行业、石油行业、煤炭行业、汽车行业、新能源汽车行业、钢铁行业、医药行业、文化创意产业、化工行业、食品制造、有色金属行业、高端装备制造、房地产业、通信行业、交通运输、旅游行业、物流行业、电子商务、零售业、服务消费、云计算、具身智能、低空经济、生物产业、大数据、健康产业、数字经济、量子科技、人工智能、智慧城市、新材料行业、电子信息制造、纺织服装、集成电路、新一代信息技术产业，</strong>每份行业年报4-7万字，通常在每年4月份发布上网。 
          </li>
        </ul>
        <p style="font-size:16px;text-align:center;padding:0px 0px 5px 0px;">
          <strong>行业年报内容框架及说明</strong>
        </p>
        <table class="table table1" border="1" width="95%" cellspacing="0" cellpadding="0">
          <tr style="background: #0770b9; color:#fff;">
            <th>框架结构</th>
            <th>内容说明</th>
          </tr>
          <tr style="color:black;">
            <td style="width:125px;">行业发展环境分析</td>
            <td>本部分内容主要监测和解读产业发展所面临的宏观经济环境、产业政策环境、技术环境、贸易环境以及产业链上下游等，尤其注重持续跟踪、研究国家有关政策（特别是产业政策）发展变化给该行业发展带来的影响。</td>
          </tr>
          <tr style="color:black;">
            <td>行业整体运行情况</td>
            <td>本部分内容主要基于相关机构发布的数据，图文并茂，通过描述行业景气情况、固定资产投资、市场供求、价格走势、进出口以及经济效益等指标，展现行业现状及特点。</td>
          </tr>
          <tr style="color:black;">
            <td>行业竞争格局分析</td>
            <td>本部分内容主要针对行业区域特征、市场结构以及企业竞争格局等方面进行分析，并重点剖析行业内重点企业运营状况、经营策略和竞争优势等，为投资者揭示企业的投资机会和风险。</td>
          </tr>
          <tr style="color:black;">
            <td>发展趋势预测</td>
            <td>本部分内容主要是利用科学的分析方法，对宏观经济形势、产业政策动向以及行业主要运行指标的中短期发展趋势进行分析预测。</td>
          </tr>
          <tr style="color:black;">
            <td>投资机会与风险</td>
            <td>本部分内容主要对行业投资机会与风险进行分析。投资机会分析包括投资环境、投资潜力、投资吸引力等方面；风险分析包括宏观经济、上下游产业等外围环境给行业带来的风险以及该行业所面临的政策性风险、运营风险、财务风险等；并在此基础上给出投资建议。</td>
          </tr>
          
        </table>
        <p style="color:red;padding:10px 0px;">注：由于各行业特点不同，上述框架只供参考，最终框架以各行业报告终稿为准。</p>

        <h3 class="title">产品特点及使用价值</h3>
        <ul>
          <li>
            <strong>权威数据为本：</strong>国研网“年度报告”除了依托国家统计局、国家发改委、海关总署、中国人民银行等权威部门发布的数据外，还通过聘请相关领域权威专家作为顾问，利用其在金融/行业管理和研究中积累的大量经验，以图文并茂的形式，分析金融/行业主要运行指标发展变化趋势，揭示金融/行业发展变化的规律，以及因此带来的发展风险和机遇。
          </li>
          <li>
            <strong>深度研究分析：</strong>从金融/行业基本运行情况、产业政策解读、重点企业发展情况到发展趋势预测体现了深度分析研究的特点。报告力求以全球化的视角、国内外市场相互联系、相互影响等方面全方位分析金融/行业的总体运行态势，结合国家产业政策及其调整方向，金融/行业内重点企业的经营与发展状况，对金融/行业发展中出现的热点或重点问题进行深入的研究剖析，从而推断未来中短期内金融/行业发展趋势和政策走向，客观评价金融/行业投资机会和投资风险。
          </li>
          <li>
            <strong>战略决策参考：</strong>通过对金融/行业政策环境、总体发展现状、运行趋势和热点、重点问题的深入剖析与探讨，为有关政府部门制定宏观经济政策或产业政策、为投资者和行业从业者捕捉行业投资机会和预测发展前景、为企事业单位有关部门制定发展战略、进行风险评估和投资决策提供重要参考。
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="热点报告">
        <h3 class="title">内容介绍</h3>
        <p>
          <strong>国研网系列“热点报告”</strong>针对宏观经济、金融领域、重点行业发展中的热点、重点问题进行深入分析探讨，揭示变化影响，阐述独到见解，进行趋势预测、提供对策建议。
        </p>
        <p>
          目前国研网已推出
          <strong>36</strong>种热点报告，其中包括
          <strong>1</strong>宏观经济热点分析报告、
          <strong>11</strong>金融热点分析报告，
          <strong>22</strong>种行业热点分析报告、
          <strong>2</strong>种政策会议分析热点报告。
        </p>
        
        <ul>
          <li>
            <strong>宏观经济热点报告：</strong>每月更新2篇。
          </li>
          <li>
            <strong>金融及综合类热点报告</strong>涉及领域：
            <strong>国际金融、国内金融、科技创新、绿色金融、养老金融、双碳经济、地方债、投融资、银行、保险、证券，</strong>每个领域每两个月至少更新1篇。
          </li>
          <li>
            <strong>行业热点报告</strong>涉及行业：
            <strong>农业、电力行业、新能源行业、石油行业、煤炭行业、汽车行业、新能源汽车行业、钢铁行业、医药行业、文化创意产业、化工行业、食品制造、有色金属行业、高端装备制造、房地产业、通信行业、电子信息制造、交通运输、旅游行业、物流行业、电子商务、零售业，</strong>每个行业每两月更新1篇。
          </li>
          <li>
            <strong>政策会议热点报告：重要政策分析、重要会议分析。</strong>
          </li>
        </ul>
        <h3 class="title">使用价值</h3>
        <ul>
          <li>帮助用户全面及时地了解国内外宏观经济、金融、行业领域的重要政策与重大事件、把握国内市场运行态势。</li>
          <li>科学解读政府有关政策，预测政策变化趋势，揭示政策变化给行业有关各方带来的风险和机会。</li>
          <li>分析重点热点问题出现的背景原因、现状和影响，对未来的走势进行预测和判断，提出解决问题或回避风险抓住机遇的对策建议，为用户进行科学研究、管理决策提供参考。</li>
        </ul>
      </el-tab-pane>
    </el-tabs>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/Top";
import Footer from "@/components/Footer";
export default {
  components: {
    Top,
    Footer
  },
  data() {
    return {
      tabPosition: "left"
    };
  }
};
</script>

<style lang='less' scoped>
.title,
.title_b {
  padding-top: 20px;
  padding-bottom: 10px;
  line-height: 200%;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color: #06c;
}

.title_b {
  padding-bottom: 0px;
  line-height: 200%;
  font-size: 16px;
}

.table {
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  font-family: verdana;
  font-size: 14px;
  line-height: 200%;
  margin: 0 auto;
}

.table1 td {
  text-align: left;
  line-height: 20px;
}

th,
td {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  text-align: center;
  padding: 15px 10px;
  line-height: 18px;
}

td {
  padding: 10px 5px;
  line-height: 18px;
}

p {
  font-size: 14px;
  line-height: 26px;
  text-indent: 2em;
}

ul {
  padding: 10px 20px;
}

li {
  line-height: 33px;
  list-style-type: disc;
}

/deep/.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  font-weight: 700;
}

/deep/.el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}

/deep/.el-tabs__header {
  width: 150px;
}

/deep/.el-tabs--border-card .el-tabs__content {
  padding: 15px 30px;
}
</style>